var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-alertas-bloco"},[_c('div',{staticClass:"alerta-bloco"},[_c('div',{staticClass:"alerta-bloco--esquerda"},[_vm._m(0),_c('div',{staticClass:"bloco-dados"},[_c('div',{staticClass:"bloco-interno"},[_vm._t("default")],2)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerta-bloco--icone"},[_c('i',{staticClass:"mdi mdi-alert-circle-outline"})])
}]

export { render, staticRenderFns }